import { render } from "./themeActivityCenterCopy.vue?vue&type=template&id=f3896fda&scoped=true"
import script from "./themeActivityCenterCopy.vue?vue&type=script&lang=js"
export * from "./themeActivityCenterCopy.vue?vue&type=script&lang=js"

import "./themeActivityCenterCopy.vue?vue&type=style&index=0&id=f3896fda&scoped=true&lang=css"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3896fda"]])

export default __exports__